<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차요금정산</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차요금정산</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <!-- <li class="web">
          <p class="pageTxt">요금사전결제</p>
          <ul class="depth">
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납 주차요금">미납 주차요금</router-link></li>
          </ul>
        </li> -->
        <!-- <li>
          <p class="pageTxt">주차요금 간편조회</p>
          <ul class="depth">
            <li><router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link></li>
            <li><router-link to="/lookup" title="요금 조회/결제">요금 조회/결제</router-link></li>
            <li><router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link></li>
          </ul>
        </li> -->
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">주차요금 간편계산</h3>
        <article class="advancePayment">
          <div class="paySelect">
            <dl class="boxForm">
              <dt>주차장을 선택하세요.</dt>
              <dd>
                <ul class="parkList">
                  <li
                    v-for="(item, index) in parkingList"
                    :key="index"
                    @click="onClickParking(item)"
                    :class="item == parking ? 'active' : ''"
                  >
                    <button class="btn border-light">{{ item.PARKING_NM }}</button>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl class="boxForm">
              <dt>예상 주차시간을 선택하세요.</dt>
              <dd>
                <div class="table">
                  <table>
                    <colgroup>
                      <col style="width: 20%; min-width: 70px" />
                      <col style="width: auto" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">입차시간</th>
                        <td>
                          <date-picker :sDateTime="sDateTime" @emitSDate="emitSDate"></date-picker>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">출차시간</th>
                        <td>
                          <date-picker :sDateTime="eDateTime" @emitSDate="emitEDate"></date-picker>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </dd>
            </dl>
            <dl class="boxForm">
              <dt>할인유형을 선택하세요.</dt>
              <dd>
                <div class="table">
                  <table>
                    <colgroup>
                      <col style="width: 20%; min-width: 70px" />
                      <col style="width: auto" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">할인유형</th>
                        <td>
                          <select v-model="discountCd" title="할인유형 선택">
                            <option
                              v-for="(item, index) in discountList"
                              :key="index"
                              :value="{ id: item.code, text: item.codeNm }"
                            >
                              {{ item.codeNm }}
                            </option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </dd>
            </dl>
            <article class="btnArea">
              <button class="btn border" @click="init">초기화</button>
              <button class="btn blue" @click="getParkingAmt">조회</button>
            </article>
          </div>
          <div class="payInquiry">
            <div class="txtBox">
              입력하신 조건의<Br />예상 주차요금은
              <div class="box">{{ estimatedParkingAmt }}</div>
              원 입니다.
            </div>
          </div>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker1.vue';

export default {
  data() {
    return {
      sDateTime: {
        sDate: '',
        sTime: '',
      },
      eDateTime: {
        eDate: '',
        eTime: '',
      },
      discountList: [],
      discountCd: {
        id: 'DC001',
        text: '일반',
      },
      estimatedParkingAmt: 0,
      parkingList: [],
      parking: {},
    };
  },

  components: {
    DatePicker,
  },

  created() {
    this.getDiscountList();
    this.getParkingList();
  },

  methods: {
    init() {
      this.sDateTime = {
        sDate: '',
        sTime: '',
      };
      this.eDateTime = {
        eDate: '',
        eTime: '',
      };
      this.discountCd = {
        id: 'DC001',
        text: '일반',
      };
      this.estimatedParkingAmt = 0;
      this.parking = {};
    },

    async getDiscountList() {
      const res = await axios('get', '/api/prepay/getDiscountList.json');
      this.discountList = res.data.discountList;
    },

    async getParkingList() {
      const res = await axios('get', '/api/parking/map.json');
      this.parkingList = res.data.parkingMapList;
    },

    emitSDate(DateTime) {
      this.sDateTime = DateTime;
    },

    emitEDate(DateTime) {
      this.eDateTime = DateTime;
    },

    onClickParking(parking) {
      this.parking = parking;
    },

    async getParkingAmt() {
      if (!this.parking.SECTN_ID || this.sDateTime.sTime == '' || this.eDateTime.sTime == '') {
        alert('입력정보부족');
        return;
      }
      const res = await axios('get', '/api/prepay/easyCalculate.json', {
        sectnId: this.parking.SECTN_ID,
        inDttm: this.sDateTime.sDate + ' ' + this.sDateTime.sTime + ':00',
        outDttm: this.eDateTime.sDate + ' ' + this.eDateTime.sTime + ':00',
        discountCd: this.discountCd.id,
      });
      const data = res.data.value.result;
      this.estimatedParkingAmt = data.useAmt - data.discountAmt;
    },
  },
};
</script>
